/**
 * Maps legacy/external temple slugs to their current canonical slug.
 *
 * Temple slugs are derived from the seeded temple name, so renaming a temple
 * (e.g. "Ram Mandir" -> "Shri Ram Janmabhoomi Mandir") changes its slug and
 * breaks any pre-existing links (sitemap entries, bookmarks, indexed URLs).
 * Add an entry here whenever a slug changes so old links redirect instead of
 * landing on "Temple not found".
 */
export const TEMPLE_SLUG_ALIASES = {
  'ram-mandir': 'shri-ram-janmabhoomi-mandir',
};

/**
 * Returns the canonical slug for a given slug, or null if it isn't an alias.
 * @param {string} slug
 * @returns {string|null}
 */
export function resolveTempleSlugAlias(slug) {
  return TEMPLE_SLUG_ALIASES[slug] || null;
}
